import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {TopnavbarComponent} from "./topnavbar.component";
import { AccountService } from "../../../services/account.service";

@NgModule({
    declarations: [TopnavbarComponent],
    imports     : [BrowserModule],
    exports     : [TopnavbarComponent],
    providers   : [AccountService]
})

export class TopnavbarModule {}
